import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Comandi di «Quanto Mettere da Parte»: interruttori, Stripe, iscritti, registro eventi. */

const Bottone = ({ children, onClick, testid, tono = "chiaro" }) => (
  <button onClick={onClick} data-testid={testid}
    className={`px-4 py-2 rounded text-xs font-bold tracking-wide transition-colors ${
      tono === "oro" ? "bg-gold text-black hover:bg-gold/80" : "border border-[#0D1527]/25 text-[#0D1527] hover:bg-[#0D1527]/5"
    }`}>
    {children}
  </button>
);

const Riga = ({ k, v }) => (
  <div className="flex gap-2">
    <span className="text-[#8E9AAE] text-xs w-40 shrink-0">{k}</span>
    <span className="text-[#0D1527] text-xs font-mono break-all">{v || "—"}</span>
  </div>
);

const DatiFattura = ({ isc, h, api, onFatto, onErrore }) => {
  const f = isc.fatturazione || {};
  const [sdi, setSdi] = useState(f.sdi || "");
  const [pec, setPec] = useState(f.pec || "");
  const salva = async () => {
    try {
      await axios.post(`${api}/admin/qmdp/fatturazione`, { codice: isc.codice, sdi, pec }, h);
      onFatto("Dati per la fattura aggiornati");
    } catch (e) { onErrore(e.response?.data?.detail || "Non sono riuscito a salvare"); }
  };
  return (
    <div className="mt-3 bg-[#F6F3EC] border border-[#E2DACA] rounded p-3" data-testid={`qmdp-fattura-${isc.codice.slice(0, 6)}`}>
      <p className="text-[#8A6A28] text-[10px] tracking-[0.2em] mb-2">DATI PER LA FATTURA</p>
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1">
        <Riga k="Ragione sociale" v={f.ragione_sociale || isc.nome} />
        <Riga k="Partita IVA" v={f.partita_iva} />
        <Riga k="Codice fiscale" v={f.codice_fiscale} />
        <Riga k="Indirizzo" v={[f.indirizzo, f.indirizzo2].filter(Boolean).join(", ")} />
        <Riga k="Città" v={[f.cap, f.citta, f.provincia && `(${f.provincia})`].filter(Boolean).join(" ")} />
        <Riga k="Paese" v={f.paese} />
      </div>
      <div className="grid sm:grid-cols-2 gap-3 mt-3">
        <label className="block">
          <span className="text-[#8E9AAE] text-[11px]">Codice destinatario SDI</span>
          <input value={sdi} onChange={(e) => setSdi(e.target.value.toUpperCase())}
            className="w-full mt-1 bg-white border border-[#D9D2C5] rounded px-2 py-1.5 text-xs font-mono"
            data-testid={`qmdp-sdi-${isc.codice.slice(0, 6)}`} />
        </label>
        <label className="block">
          <span className="text-[#8E9AAE] text-[11px]">PEC</span>
          <input value={pec} onChange={(e) => setPec(e.target.value)}
            className="w-full mt-1 bg-white border border-[#D9D2C5] rounded px-2 py-1.5 text-xs font-mono"
            data-testid={`qmdp-pec-${isc.codice.slice(0, 6)}`} />
        </label>
      </div>
      <div className="flex flex-wrap gap-3 mt-3">
        <Bottone testid={`qmdp-salva-fattura-${isc.codice.slice(0, 6)}`} onClick={salva}>SALVA SDI / PEC</Bottone>
        <Bottone testid={`qmdp-reinvia-${isc.codice.slice(0, 6)}`}
          onClick={async () => {
            try {
              await axios.post(`${api}/admin/qmdp/reinvia-acquisto`, { codice: isc.codice }, h);
              onFatto("Mail «Acquisto:» con i dati fiscali rimandata allo studio");
            } catch (e) { onErrore(e.response?.data?.detail || "Invio non riuscito"); }
          }}>
          RIMANDA LA MAIL «ACQUISTO:»
        </Bottone>
      </div>
    </div>
  );
};

export const QmdpGestionePanel = ({ token }) => {
  const h = { headers: { Authorization: `Bearer ${token}` } };
  const [imp, setImp] = useState(null);
  const [iscritti, setIscritti] = useState([]);
  const [eventi, setEventi] = useState({ eventi: [], invii: [] });
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const carica = async () => {
    try {
      const [a, b, c] = await Promise.all([
        axios.get(`${API}/admin/qmdp/impostazioni`, h),
        axios.get(`${API}/admin/qmdp/iscritti`, h),
        axios.get(`${API}/admin/qmdp/eventi`, h),
      ]);
      setImp(a.data); setIscritti(b.data); setEventi(c.data);
    } catch (e) { setErr("Non riesco a leggere i dati del servizio"); }
  };

  useEffect(() => { carica(); /* eslint-disable-next-line */ }, []);

  const azione = async (fn, testo) => {
    setErr(null); setMsg(null);
    try { await fn(); setMsg(testo); await carica(); }
    catch (e) { setErr(e.response?.data?.detail || "Operazione non riuscita"); }
  };

  if (!imp) return <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6 text-[#64708A]">Caricamento…</div>;

  return (
    <div className="space-y-6" data-testid="qmdp-gestione-panel">
      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6">
        <h4 className="font-heading text-lg text-[#0D1527] mb-4">INTERRUTTORI</h4>
        <div className="flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-3">
            <span className={`text-sm font-bold ${imp.vendita_attiva ? "text-[#2F6B3C]" : "text-[#9A3B3B]"}`}
              data-testid="qmdp-stato-vendita">
              Vendita {imp.vendita_attiva ? "ACCESA" : "SPENTA"}
            </span>
            <Bottone testid="qmdp-toggle-vendita" tono={imp.vendita_attiva ? "chiaro" : "oro"}
              onClick={() => azione(
                () => axios.post(`${API}/admin/qmdp/vendita`, { attiva: !imp.vendita_attiva }, h),
                imp.vendita_attiva ? "Vendita spenta" : "Vendita accesa")}>
              {imp.vendita_attiva ? "SPEGNI LA VENDITA" : "ACCENDI LA VENDITA"}
            </Bottone>
          </div>
          <div className="flex items-center gap-3">
            <span className={`text-sm font-bold ${imp.mail_attive ? "text-[#2F6B3C]" : "text-[#9A3B3B]"}`}
              data-testid="qmdp-stato-mail">
              Mail automatiche {imp.mail_attive ? "ACCESE" : "SPENTE"}
            </span>
            <Bottone testid="qmdp-toggle-mail"
              onClick={() => azione(
                () => axios.post(`${API}/admin/qmdp/mail-attive`, { attive: !imp.mail_attive }, h),
                imp.mail_attive ? "Mail automatiche spente" : "Mail automatiche accese")}>
              {imp.mail_attive ? "SPEGNI LE MAIL" : "ACCENDI LE MAIL"}
            </Bottone>
          </div>
        </div>
        <p className="text-[#8E9AAE] text-xs mt-4">
          A vendita spenta la scheda in /strumenti, la riga in /forfettari e il pulsante ATTIVA ORA restano nascosti.
          Gli abbonati già attivi non vengono toccati. A mail spente le mail del mese partono solo agli iscritti di prova.
        </p>
      </div>

      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6">
        <h4 className="font-heading text-lg text-[#0D1527] mb-4">STRIPE</h4>
        <div className="grid sm:grid-cols-2 gap-4">
          {["live", "test"].map((modo) => (
            <div key={modo} className="bg-white border border-[#E8E2D5] rounded p-4" data-testid={`qmdp-stripe-${modo}`}>
              <p className="text-[#64708A] text-[11px] tracking-[0.2em] mb-2">{modo === "live" ? "VENDITA VERA" : "MODALITÀ DI PROVA"}</p>
              <p className="text-[#0D1527] text-xs font-mono break-all">prodotto: {imp[modo]?.product_id || "—"}</p>
              <p className="text-[#0D1527] text-xs font-mono break-all">prezzo: {imp[modo]?.price_id || "—"}</p>
              <p className="text-[#0D1527] text-xs font-mono break-all">portale: {imp[modo]?.portal_id || "—"}</p>
              <div className="mt-3">
                <Bottone testid={`qmdp-setup-${modo}`}
                  onClick={() => azione(() => axios.post(`${API}/admin/qmdp/stripe-setup`, { modo }, h),
                    `Stripe ${modo}: prodotto, prezzo e portale pronti`)}>
                  CREA / VERIFICA
                </Bottone>
              </div>
            </div>
          ))}
        </div>
        {!imp.chiavi_prova && (
          <p className="text-[#9A3B3B] text-xs mt-4" data-testid="qmdp-chiavi-prova-mancanti">
            Chiavi Stripe di prova non configurate: la modalità di prova non è disponibile.
          </p>
        )}
      </div>

      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6">
        <h4 className="font-heading text-lg text-[#0D1527] mb-4">INVII FORZATI</h4>
        <div className="flex flex-wrap gap-3">
          <Bottone testid="qmdp-forza-domanda"
            onClick={() => azione(() => axios.post(`${API}/admin/scheduler/run/qmdp-domanda`, {}, h),
              "Domanda del mese inviata")}>
            FORZA LA DOMANDA DEL MESE
          </Bottone>
          <Bottone testid="qmdp-forza-promemoria"
            onClick={() => azione(() => axios.post(`${API}/admin/scheduler/run/qmdp-promemoria`, {}, h),
              "Promemoria inviato")}>
            FORZA IL PROMEMORIA
          </Bottone>
        </div>
        <p className="text-[#8E9AAE] text-xs mt-3">
          In automatico: domanda il 1° del mese alle 8:00, promemoria il 5 alle 8:00 (ora italiana), una sola volta
          e solo a chi non ha ancora risposto.
        </p>
      </div>

      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <h4 className="font-heading text-lg text-[#0D1527]">ISCRITTI ({iscritti.length})</h4>
          <Bottone testid="qmdp-scarica-fatturazione" tono="oro"
            onClick={async () => {
              setErr(null);
              try {
                const { data } = await axios.get(`${API}/admin/qmdp/fatturazione.csv?t=${Date.now()}`,
                  { ...h, responseType: "blob" });
                const a = document.createElement("a");
                a.href = URL.createObjectURL(data);
                a.download = "qmdp-fatturazione.csv";
                a.click();
                URL.revokeObjectURL(a.href);
                setMsg("File dei dati di fatturazione scaricato");
              } catch (e) { setErr("Non sono riuscito a preparare il file"); }
            }}>
            SCARICA I DATI PER FATTURARE
          </Bottone>
        </div>
        <div className="space-y-2 max-h-80 overflow-auto" data-testid="qmdp-iscritti">
          {iscritti.map((i) => (
            <div key={i.codice} className="bg-white border border-[#E8E2D5] rounded p-3 text-sm">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="text-[#0D1527] font-bold">
                  {i.nome || "—"} {i.prova && <span className="text-[#8A6A28] text-[10px] tracking-wider">PROVA</span>}
                  {i.escluso_riepilogo && !i.prova && <span className="text-[#8A6A28] text-[10px] tracking-wider"> PROVA INTERNA</span>}
                  {i.disdetta_a_fine_periodo && <span className="text-[#9A3B3B] text-[10px] tracking-wider"> DISDETTO A FINE PERIODO</span>}
                </span>
                <span className="text-[#64708A] text-xs">{i.email}</span>
                <span className={`text-xs font-bold ${i.stato === "attivo" ? "text-[#2F6B3C]" : "text-[#9A3B3B]"}`}>
                  {(i.stato || "attivo").toUpperCase()}
                </span>
              </div>
              <div className="flex flex-wrap items-center gap-3 mt-2">
                <a className="text-[#2F7DBF] text-xs underline" href={`/quanto-mettere-da-parte/scheda/${i.codice}`} target="_blank" rel="noreferrer">scheda</a>
                <a className="text-[#2F7DBF] text-xs underline" href={`/quanto-mettere-da-parte/incasso/${i.codice}`} target="_blank" rel="noreferrer">incasso</a>
                <span className="text-[#8E9AAE] text-xs">{i.scheda_compilata ? "scheda compilata" : "scheda da compilare"}</span>
                <Bottone testid={`qmdp-escludi-${i.codice.slice(0, 6)}`}
                  onClick={() => azione(() => axios.post(`${API}/admin/qmdp/escludi-riepilogo`,
                    { codice: i.codice, escluso: !i.escluso_riepilogo }, h),
                    i.escluso_riepilogo ? "Rientra nel riepilogo" : "Segnato come prova interna")}>
                  {i.escluso_riepilogo ? "RIMETTI NEL RIEPILOGO" : "SEGNA PROVA INTERNA"}
                </Bottone>
                <Bottone testid={`qmdp-azzera-${i.codice.slice(0, 6)}`}
                  onClick={() => azione(async () => {
                    const { data } = await axios.post(`${API}/admin/qmdp/azzera-prova`, { codice: i.codice }, h);
                    setMsg(`Prova azzerata (${data.mesi_azzerati} mesi cancellati)`);
                  }, null)}>
                  AZZERA LA PROVA
                </Bottone>
                <Bottone testid={`qmdp-rimborso-${i.codice.slice(0, 6)}`}
                  onClick={() => azione(async () => {
                    const { data } = await axios.post(`${API}/admin/qmdp/rimborso`, { codice: i.codice }, h);
                    setMsg(`Rimborsati ${data.importo.toFixed(2)} € (${data.giorni_totali - data.giorni_usati} giorni su ${data.giorni_totali})`);
                  }, null)}>
                  RIMBORSA IL RECESSO
                </Bottone>
              </div>
              <DatiFattura isc={i} h={h} api={API} onFatto={(m) => { setErr(null); setMsg(m); carica(); }}
                onErrore={(m) => { setMsg(null); setErr(m); }} />
            </div>
          ))}
          {iscritti.length === 0 && <p className="text-[#8E9AAE] text-sm">Nessun iscritto.</p>}
        </div>
      </div>

      <div className="bg-[#FAF8F5] border border-[#E8E2D5] rounded-lg p-6">
        <h4 className="font-heading text-lg text-[#0D1527] mb-4">REGISTRO EVENTI STRIPE</h4>
        <div className="space-y-1 max-h-72 overflow-auto text-xs" data-testid="qmdp-eventi">
          {eventi.eventi.map((e) => (
            <div key={e.id} className="flex flex-wrap gap-3 border-b border-[#E8E2D5] py-1">
              <span className="text-[#64708A] font-mono">{(e.creato_il || "").slice(0, 16).replace("T", " ")}</span>
              <span className="text-[#0D1527] font-bold">{e.tipo}</span>
              <span className="text-[#8A6A28]">{e.modo}</span>
              <span className="text-[#64708A] break-all">{e.dati?.email || e.dati?.codice || ""}</span>
            </div>
          ))}
          {eventi.eventi.length === 0 && <p className="text-[#8E9AAE]">Nessun evento registrato.</p>}
        </div>
        <h4 className="font-heading text-lg text-[#0D1527] mt-6 mb-3">EMAIL INVIATE</h4>
        <div className="space-y-1 max-h-72 overflow-auto text-xs" data-testid="qmdp-invii">
          {eventi.invii.map((e) => (
            <div key={e.id} className="flex flex-wrap gap-3 border-b border-[#E8E2D5] py-1">
              <span className="text-[#64708A] font-mono">{(e.inviata_il || "").slice(0, 16).replace("T", " ")}</span>
              <span className="text-[#0D1527]">{e.oggetto}</span>
              <span className="text-[#64708A]">{e.a}</span>
            </div>
          ))}
          {eventi.invii.length === 0 && <p className="text-[#8E9AAE]">Nessuna email inviata.</p>}
        </div>
      </div>

      {msg && <p className="text-[#2F6B3C] text-sm" data-testid="qmdp-gestione-msg">{msg}</p>}
      {err && <p className="text-red-600 text-sm" data-testid="qmdp-gestione-err">{err}</p>}
    </div>
  );
};
